import React from 'react';

export const textRenderer = (params: any) => params?.value ? (
  <span className="ag-cell-value" title={params?.value}>{params?.value}</span>
) : params?.valueFormatted;
